const createArrow = () => {
    const arrow = document.createElement('div');
    arrow.classList.add('go-top-arrow');
    arrow.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none"><circle cx="20" cy="20" r="20" fill="#FF206E" opacity=".6"/><path stroke="#fff" stroke-linecap="round" stroke-width="1.5" d="M20 28.4V11.6M26 17.2l-6-5.6-6 5.6"/></svg>
    `;
    document.querySelector('body').prepend(arrow);
};

createArrow();

const goTop = () => {
    window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
};

const buttonGoTop = document.querySelector('.go-top-arrow');

const checkOffset = () => {
    const header = document.querySelector('header');
    const scrolledArea = -document.body.getBoundingClientRect().top;

    if (scrolledArea < header.getBoundingClientRect().height) {
        buttonGoTop.style.position = 'absolute';
        buttonGoTop.style.visibility = 'hidden';
    } else {
        buttonGoTop.style.position = 'fixed';
        buttonGoTop.style.visibility = 'visible';
    }
}

if (buttonGoTop) {
    buttonGoTop.addEventListener('click', (e) => {
        e.stopPropagation();
        goTop();
    });
    document.addEventListener('scroll', checkOffset);
}
